import React from 'react';
import Flags from '../../StatusBadges/mappings';

interface SearchFlagProps {
  flag: string;
}

const SearchFlag: React.FC<SearchFlagProps> = ({ flag }) => {
  const Flag = Flags[flag];
  if (!Flag) {
    return <div>N/A</div>;
  }
  return <Flag compact={false} />;
};

export default SearchFlag;
